<template>
  <div>
    <header-carousel />
    <main-content />
  </div>
</template>

<script>
import HeaderCarousel from '../components/carousels/HeaderCarousel.vue'
import MainContent from '../components/content/MainContent.vue'

export default {
  name: 'Home',
  components: {
    HeaderCarousel,
    MainContent
  },
  data() {
    return {
    }
  }
}
</script>
